export default __webpack_public_path__ + "static/media/Vector.ae489667.svg";